import "./App.css";
import Navbar from "./components/NavBar/Navbar";
import Home from "./components/Home/Home";
import Starred from "./components/ImportantFileList/Starred";
import SharedFile from "./components/SharedFiles/SharedFile";
import RecycleBin from "./components/RecycleBin/RecycleBin";
import TopNav from "./components/TopNav/TopNav";
import ShortMSG from "./components/ShortMSG/ShortMSG";
import LoginPage from "./components/Login-signup/LoginPage/LoginPage";
import { useState, useEffect } from "react";

import { Route, Routes } from "react-router-dom";

import { useSelector } from "react-redux";
import axios from "axios";

import store from "./Redux/Store";
import { Provider } from "react-redux";

function App() {
  // State of NavBar
  const [nav, setnav] = useState(false);
  const userData = useSelector((state) => state.user);
  const [loginStatus, setLoginStatus] = useState(false);
  useEffect(() => {
    setLoginStatus(() => localStorage.getItem("userLoginStatus"));
  }, []);
  return (
    <div className="App">
      {userData && userData.isLoggedIn ? (
        <div className="app">
          <TopNav nav={nav} setnav={setnav} />
          <Navbar nav={nav} setnav={setnav} />

          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/home" exact element={<Home />} />
            <Route path="/starred" exact element={<Starred />} />
            <Route path="/sharedFile" exact element={<SharedFile />} />
            <Route path="/recycle-bin" exact element={<RecycleBin />} />
          </Routes>
          <ShortMSG />
        </div>
      ) : (
        <LoginPage />
      )}
      {/* <div className="app">
          <TopNav nav={nav} setnav={setnav} />
          <Navbar nav={nav} setnav={setnav} />

          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/home" exact element={<Home />} />
            <Route path="/starred" exact element={<Starred />} />
            <Route path="/sharedFile" exact element={<SharedFile />} />
            <Route path="/recycle-bin" exact element={<RecycleBin />} />
          </Routes>
          <ShortMSG />
        </div> */}
    </div>
  );
}

export default App;
